/**
 * Global Mixins!
 */

import ApiService from '../services/ApiService';
import UserAuthenticateModel from '../models/UserAuthenticateModel';
import UserTokenService from '../services/AdminsTokensService';

export default {
  methods: {
    /**
     * User login.
     * @param {object} creds Login and Password
     * @returns {Promise<any>}
     */
    userLogin(creds) {
      return new Promise((resolve, reject) => {
        ApiService.request('POST', 'admin/login', creds).then(response => {
          if (response.status === 201) {
            const { data } = response;
            const user = new UserAuthenticateModel(data);
            this.$store.commit('user', user);
            UserTokenService.setToken(data.token.token, data.token.expire_at);
            resolve();
          } else {
            throw new Error();
          }
        }).catch(() => {
          reject(new Error());
        });
      });
    },
    /**
     * User logout.
     */
    userLogout() {
      this.$store.commit('user', null);
      UserTokenService.removeToken();
      this.$router.push({ name: 'Login' });
    },
    /**
     * Returns user information.
     * @returns {*}
     */
    user() {
      if (UserTokenService.getToken() === null) {
        return null;
      }
      return this.$store.getters.user;
    },
  },
  computed: {
    /**
     * Return a username
     */
    username() {
      if (this.user() !== null) {
        return this.user().beautifyName();
      }
      return '';
    },
  },
};
